module.exports = __webpack_public_path__ + "img/AMATIC.99050b84.png";